<template>
  <li class="members__item">
    <a class="picture-morph" :href="`/participants-page/${member.id}`">
      <BaseLazyLoadingimg
        class="picture-morph__img"
        :srcSet="[srcset[0], srcset[1], srcset[2]]"
      />
      <div class="picture-morph__wrap">
        <svg
          class="picture-morph__svg"
          width="10"
          height="10"
          viewBox="0 0 10 10"
          preserveAspectRatio="none"
        >
          <path
            ref="start"
            class="picture-morph__path"
            d="M 10 10 L 10 10 C 10 10 10 10 5 10 C 0 10 0 10 0 10 L 0 10 Z"
          ></path>
        </svg>
      </div>
      <div ref="content" class="picture-morph__content">
        <BaseCaption :text="member.memberName" />
        <BaseText :text="member.memberDescr" />
      </div>
    </a>
  </li>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  name: 'MembersListItem',
  data() {
    return {
      coords: {
        open: [
          'M 0,10 L 10,10 L 10,10 C 10,10 10,10 5,10 C 0,10 0,10 0,10 Z',
          'M 0,10 L 10,10 L 10,10 C 10,10 10,5 5,5 C 0,5 0,10 0,10 Z',
          'M 0,10 L 10,10 L 10,0 C 10,0 10,0 5,0 C 0,0 0,0 0,0 Z'
        ],
        close: [
          'M 10,10 L 10,0 C 10,0 10,0 5,0 C 0,0 0,0 0,0 L 0,10 Z',
          'M 10,10 L 10,0 C 10,0 10,5 5,5 C 0,5 0,0 0,0 L 0,10 Z',
          'M 10,10 L 10,10 C 10,10 10,10 5,10 C 0,10 0,10 0,10 L 0,10 Z'
        ]
      }
    }
  },
  props: {
    member: {
      required: true,
      type: Object
    }
  },
  computed: {
    ...mapGetters('data', ['RESOURCES_URL']),
    srcset() {
      if (this.member.optimizedImages && this.member.optimizedImages.src) {
        if (Object.values(this.member.optimizedImages.src)[0]) {
          return Object.values(this.member.optimizedImages.src)
        }

        return [this.member.imgUrl, this.member.imgUrl, this.member.imgUrl]
      } else {
        return [this.member.imgUrl, this.member.imgUrl, this.member.imgUrl]
      }
    }
  },
  mounted() {
    const start = this.$refs.start
    const content = this.$refs.content

    this.$el.addEventListener('mouseleave', () => {
      const tl = new TimelineMax()

      tl.add(
        TweenMax.to(start, 0.5, {
          morphSVG: this.coords.close[0],
          ease: Power2.easeInOut
        })
      )

      tl.add(
        TweenMax.to(start, 0.5, {
          morphSVG: this.coords.close[1],
          ease: Power2.easeInOut
        }),

        TweenMax.to(content, 0.5, {
          opacity: 0,
          y: 30
        })
      )

      tl.add(
        TweenMax.to(start, 0.5, {
          morphSVG: this.coords.close[2],
          ease: Power2.easeInOut
        })
      )
    })

    this.$el.addEventListener('mouseenter', () => {
      const tl = new TimelineMax()

      tl.add(
        TweenMax.to(start, 0.5, {
          morphSVG: this.coords.open[0],
          ease: Power2.easeInOut
        })
      )

      tl.add(
        TweenMax.to(start, 0.5, {
          morphSVG: this.coords.open[1],
          ease: Power2.easeInOut
        }),

        TweenMax.to(content, 0.5, {
          opacity: 1,
          y: 0
        })
      )

      tl.add(
        TweenMax.to(start, 0.5, {
          morphSVG: this.coords.open[2],
          ease: Power2.easeInOut
        })
      )
    })
  }
}
</script>

<style lang="scss">
.picture-morph {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 195px;
  overflow: hidden;
  text-decoration: none;

  &__img {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 195px;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  &__wrap {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    fill: #0d0d0d;
  }

  &__svg {
    fill: #f3e89b;
    width: 100%;
    height: 100%;
  }

  &__path {
    position: relative;
    z-index: 2;
  }

  &__content {
    position: relative;
    transform: translate3d(0, 30px, 0);
    opacity: 0;
    text-decoration: none;
  }

  &__front {
    float: left;
    color: rgb(0, 0, 0);
  }

  &__back {
    position: absolute;
    top: 0;
    left: 0;
    color: rgb(255, 255, 255);
  }
}

@include media-min($tablet-width) {
  .picture-morph {
    height: 236px;

    &__img {
      height: 236px;
    }
  }
}

@include media-min($desktop-width) {
  .picture-morph {
    height: 380px;

    &__img {
      height: 380px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// components/MembersListItem.vue